import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '@mui/base';
import { styled, alpha } from '@mui/material';
import { forwardRef } from 'react';
import { shouldForwardPropHelper } from '../../utils/shouldForwardHelper.js';
import { BANNER_ITEM_COLORS } from './constans.js';

const PROPS_SET = new Set(["variant", "isTransparent"]);
function getBoxShadowButtonHover(color) {
    return `0px 1px 2px 0px ${alpha(color, 0.25)}, 0px 2px 8px 0px ${alpha("#20252b", 0.1)}`;
}
const Banner = forwardRef(function Banner(_a, ref) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(Wrapper, Object.assign({ ref: ref }, props, { children: children })));
});
function generateButtonByVariant(variant, theme, isTransparent) {
    switch (variant) {
        case "failure":
            return {
                marginLeft: theme.spacing(1.5),
                border: "none",
                color: isTransparent ? theme.palette.text.white : theme.palette.text.primary,
                backgroundColor: isTransparent
                    ? theme.palette.failure.main
                    : theme.palette.background.paper,
                "&:hover": {
                    backgroundColor: theme.palette.failure.main,
                    boxShadow: getBoxShadowButtonHover(theme.palette.failure.main),
                },
            };
        case "info":
            return {
                marginLeft: theme.spacing(1.5),
                border: "none",
                color: theme.palette.primary.main,
                backgroundColor: isTransparent ? "rgba(27, 99, 207, 0.10)" : theme.palette.background.paper,
                "&:hover": {
                    backgroundColor: theme.palette.primary.main,
                    boxShadow: getBoxShadowButtonHover(theme.palette.primary.main),
                },
            };
        case "success":
            return {
                marginLeft: theme.spacing(1.5),
                border: "none",
                color: isTransparent ? theme.palette.text.white : theme.palette.text.primary,
                backgroundColor: isTransparent
                    ? theme.palette.success.main
                    : theme.palette.background.paper,
                "&:hover": {
                    backgroundColor: theme.palette.success.main,
                    boxShadow: getBoxShadowButtonHover(theme.palette.success.main),
                },
            };
        case "alert":
            return {
                marginLeft: theme.spacing(1.5),
                border: "none",
                color: isTransparent ? theme.palette.text.secondary : theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
                "&:hover": {
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.secondary,
                    boxShadow: getBoxShadowButtonHover(theme.palette.background.paper),
                },
            };
        default:
            return {};
    }
}
function generateLinkTextButtonByVariant(variant, theme, isTransparent) {
    switch (variant) {
        case "failure":
            return {
                marginLeft: theme.spacing(1.5),
                fontWeight: theme.typography.fontWeightMedium,
                color: isTransparent ? theme.palette.failure.main : theme.palette.text.white,
            };
        case "info":
            return {
                marginLeft: theme.spacing(1.5),
                fontWeight: theme.typography.fontWeightMedium,
                color: isTransparent ? theme.palette.primary.main : theme.palette.text.white,
            };
        case "success":
            return {
                marginLeft: theme.spacing(1.5),
                fontWeight: theme.typography.fontWeightMedium,
                color: isTransparent ? BANNER_ITEM_COLORS.success : theme.palette.text.white,
            };
        case "alert":
            return {
                marginLeft: theme.spacing(1.5),
                fontWeight: theme.typography.fontWeightMedium,
                color: isTransparent ? BANNER_ITEM_COLORS.alert : theme.palette.text.high,
            };
    }
}
function generateBannerVariant(variant, isTransparent, theme) {
    const alphaValue = isTransparent ? 0.1 : 1;
    switch (variant) {
        case "failure":
            return {
                backgroundColor: alpha(theme.palette.failure.main, alphaValue),
                color: isTransparent ? theme.palette.failure.main : theme.palette.text.white,
            };
        case "info":
            return {
                backgroundColor: alpha(theme.palette.primary.main, alphaValue),
                color: isTransparent ? theme.palette.primary.main : theme.palette.text.white,
            };
        case "success":
            return {
                backgroundColor: alpha(theme.palette.success.main, alphaValue),
                color: isTransparent ? BANNER_ITEM_COLORS.success : theme.palette.text.white,
            };
        case "alert":
            return {
                backgroundColor: alpha(theme.palette.progress.main, alphaValue),
                color: isTransparent ? BANNER_ITEM_COLORS.alert : theme.palette.text.high,
            };
    }
}
const Wrapper = styled("div", {
    shouldForwardProp: (prop) => shouldForwardPropHelper(prop, PROPS_SET),
})(({ theme, variant, isTransparent }) => (Object.assign({ justifyContent: "space-between", alignItems: "center", display: "flex", padding: theme.spacing(1.5, 4) }, generateBannerVariant(variant, isTransparent, theme))));
const Content = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    "& h6": {
        fontWeight: theme.typography.fontWeightRegular,
    },
}));
const IconWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 24,
    height: 24,
    marginRight: theme.spacing(1.5),
}));
const Button = styled(Button$1)(({ theme }) => ({
    width: 24,
    height: 24,
    padding: 0,
    color: theme.palette.text.white,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    marginLeft: theme.spacing(1.5),
}));

export { Banner, Button, Content, IconWrapper, Wrapper, generateButtonByVariant, generateLinkTextButtonByVariant };
//# sourceMappingURL=Banner.js.map
